<div [class.block-loader]="currentImportLoader.isLoading">
	<div class="modal-header">
		<h2 translate="Import.Creation.Synthesis.Labels.DocumentsCompleted"></h2>
		<button type="button" data-cy="ModalClose" class="modal-button-close far fa-times" (click)="dismiss.emit()"></button>
	</div>

	<div class="content-block-negative"
		[class.block-loader]="completedAccountingListLoader.isLoading">
		<!-- <completed-accounting-list-table [list]="completedAccountingList$ | async" [listLoader]="completedAccountingListLoader" /> -->
	</div>

	<div class="form-actions form-actions-spaced">
		<button type="submit"
				ngbAutofocus
				class="btn btn-primary"
				(click)="download.emit()"><i
			class="far fa-arrow-to-bottom"></i>&nbsp;&nbsp;{{ ('Actions.Download' | translate) }}</button>
	</div>
</div>
